var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "flowType2" },
    [
      _c(
        "b-form-group",
        { class: { "error-input": _vm.$v.flow.name.$error } },
        [
          _c("label", [_vm._v("Flow Name*")]),
          _vm._v(" "),
          _c("j-input", {
            attrs: { "max-length": 25, placeholder: "Flow Name" },
            model: {
              value: _vm.flow.name,
              callback: function($$v) {
                _vm.$set(_vm.flow, "name", $$v)
              },
              expression: "flow.name"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-form-group",
        { class: { "error-input": _vm.$v.flow.division.$error } },
        [
          _c("label", [_vm._v("Division*")]),
          _vm._v(" "),
          _c("j-single-select", {
            attrs: {
              options: _vm.all_division_list,
              "default-data":
                _vm.mode === "create" ? null : _vm.default_division,
              placeholder: "Ex: Finance",
              "value-format": "object",
              label: "name"
            },
            on: { getData: _vm.getDataDivision },
            model: {
              value: _vm.flow.division,
              callback: function($$v) {
                _vm.$set(_vm.flow, "division", $$v)
              },
              expression: "flow.division"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-dad6417c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dad6417c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/form/flow/jFormFlowType2.vue
// module id = null
// module chunks = 